import styled, { css } from 'styled-components';

const MenuItem = styled.div`
  color: var(--grey800);
  padding: 5px 10px;
  cursor: pointer;

  &:first-of-type {
    border-radius: 5px 5px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 5px 5px;
  }

  &:hover {
    background-color: var(--grey100);
  }

  & + & {
    border-top: solid var(--grey100) 1px;
  }

  ${(props) =>
    !props.enabled &&
    css`
      cursor: default;
      pointer-events: none;
      background-color: var(--grey100);
      color: var(--grey700);
    `}
`;

export default MenuItem;
